import styled from 'styled-components';

import {
  gemAnimation,
  reversedGemAnimation,
} from '@/modules/jackpot/components/JackpotGemsPack/styled';
import { device } from '@/styles/helpers';

export const ScTopSection = styled.div`
  position: relative;
  margin-top: -96px;
  padding: 104px 16px 0;
  overflow: hidden;

  @media (${device.mobile}) {
    padding-top: 84px;
  }

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 24px;
    border-radius: 24px 24px 0 0;
    background-color: ${({ theme }) => theme.blackColor};
    margin-top: -24px;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
  }

  & > .bg {
    object-fit: cover;
    object-position: top center;
  }

  .coins,
  .gift,
  .deskLeft,
  .deskRight {
    position: absolute;
    aspect-ratio: 1/1;
  }

  .mob {
    display: none;
    position: absolute;
    width: 100%;

    @media (${device.mobile}) {
      display: block;
      position: relative;
      margin: 0 auto;
      height: auto;
    }
  }

  .deskLeft,
  .deskRight {
    @media (${device.mobile}) {
      display: none;
    }
  }

  .coins {
    width: 160px;
    bottom: 32px;
    left: 20%;
    z-index: 2;
    animation: ${reversedGemAnimation} infinite 7s ease-out;
  }

  .gift {
    width: 200px;
    top: 200px;
    right: 250px;
    animation: ${gemAnimation} infinite 7s ease-out;
  }

  .coins,
  .gift {
    @media (${device.mobile}) {
      display: none;
    }
  }

  .deskLeft {
    left: 0;
    bottom: 0;
  }

  .deskRight {
    right: 0;
    bottom: 0;
  }
`;
